import { lazy, Suspense } from 'react';

import { Translate } from '@spazious/dollhouse-i18n';
import { Flex, Spinner, Typography } from '@spazious/dollhouse-uikit';

const LazyChangelogMarkdown = lazy(async () => {
  const { ChangelogMarkdown } = await import('./ChangelogMarkdown.js');
  return { default: ChangelogMarkdown };
});

export const Changelog: React.FC = () => {
  return (
    <Flex column gap="var(--spacing-gap)">
      <Typography size="small" variant="headline">
        <Translate>Changelog</Translate>
      </Typography>
      <Suspense fallback={<Spinner />}>
        <LazyChangelogMarkdown />
      </Suspense>
    </Flex>
  );
};
